// extracted by mini-css-extract-plugin
export default {"choice":"RadioChip_choice__b5C6V","choiceImageWrapper":"RadioChip_choiceImageWrapper__WsYMU","selected":"RadioChip_selected__KX2yn","likeAnimation":"RadioChip_likeAnimation__cAEwl"};